import { DeviceOS, SortOrder } from "./app-globals.enum";
import ChromeIcon from "../assets/images/browser/chrome.png";
import FireFoxIcon from "../assets/images/browser/mozilla.png";
import SafariIcon from "../assets/images/browser/safari.png";
import BrowserIcon from "../assets/images/browser/browser.png";

export const sortNameFunc = (data, sortOrder, propertyName) => {
  const _data = [...data];
  const dataSortedByName = _data.sort((a, b) => {
    let fa = a[propertyName] !== undefined ? a[propertyName].toLowerCase() : "";
    let fb = b[propertyName] !== undefined ? b[propertyName].toLowerCase() : "";
    if (
      (sortOrder === SortOrder.DESC && fa > fb) ||
      (sortOrder === SortOrder.ASC && fa < fb)
    ) {
      return -1;
    }
    if (
      (sortOrder === SortOrder.DESC && fa < fb) ||
      (sortOrder === SortOrder.ASC && fa > fb)
    ) {
      return 1;
    }
    return 0;
  });
  return dataSortedByName;
};

export const sortDataByPropertyFunc = (
  data,
  sortOrder,
  propertyName,
  propertySubName
) => {
  const _data = [...data];
  if (sortOrder === SortOrder.ASC) {
    if (propertySubName) {
      return _data.sort(
        (a, b) =>
          a[propertyName][propertySubName] - b[propertyName][propertySubName]
      );
    }
    return _data.sort((a, b) => a[propertyName] - b[propertyName]);
  }
  if (sortOrder === SortOrder.DESC) {
    if (propertySubName) {
      return _data.sort(
        (a, b) =>
          b[propertyName][propertySubName] - a[propertyName][propertySubName]
      );
    }
    return _data.sort((a, b) => b[propertyName] - a[propertyName]);
  }
};

export const detectBrowser = () => {
  let browser = {
    title: '',
    icon: BrowserIcon,
  };
  // Opera 8.0+
  // const isOpera =
  //   (!!window.opr && !!opr.addons) ||
  //   !!window.opera ||
  //   navigator.userAgent.indexOf(" OPR/") >= 0;
  // if (isOpera) {
  //   browser.title = "Opera";
  // }

  // Firefox 1.0+
  const isFirefox = typeof InstallTrigger !== "undefined";
  if (isFirefox) {
    browser.title = "Firefox";
    browser.icon = FireFoxIcon;
    return browser;
  }

  // Safari 3.0+ "[object HTMLElementConstructor]"
  const isSafari =
    !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/) || /constructor/i.test(window.HTMLElement) ||
    (function (p) {
      return p.toString() === "[object SafariRemoteNotification]";
    })(
      !window["safari"] ||
      (typeof safari !== "undefined" && window["safari"].pushNotification)
    );
  if (isSafari) {
    browser.title = "Safari";
    browser.icon = SafariIcon;
    return browser;
  }

  // Internet Explorer 6-11
  // const isIE = /*@cc_on!@*/ false || !!document.documentMode;
  // if (isIE) {
  //   browser.title = "Internet Explorer";
  // }

  // Edge 20+
  // const isEdge = !isIE && !!window.StyleMedia;
  // if (isEdge) {
  //   browser.title = "Edge";
  // }

  // Chrome 1 - 71
  const isChromium = window.chrome;
  const winNav = window.navigator;
  const vendorName = winNav.vendor;
  const isOpera = typeof window.opr !== "undefined";
  const isIEedge = winNav.userAgent.indexOf("Edge") > -1;
  const isIOSChrome = winNav.userAgent.match("CriOS");

  if (isIOSChrome) {
    browser.title = "Chrome";
    browser.icon = ChromeIcon;
    return browser;
  } else if (
    isChromium !== null &&
    typeof isChromium !== "undefined" &&
    vendorName === "Google Inc." &&
    isOpera === false &&
    isIEedge === false
  ) {
    browser.title = "Chrome";
    browser.icon = ChromeIcon;
    return browser;
  }

  // const isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);
  // if (isChrome) {
  //   browser.title = "Chrome";
  //   browser.icon = ChromeIcon;
  //   return browser;
  // }

  // Blink engine detection
  // var isBlink = (isChrome || isOpera) && !!window.CSS;
  return browser;
};

export const detectMobile = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
}

export const getMobileOperatingSystem = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  // Windows Phone must come first because its UA also contains "Android"
  if (/windows phone/i.test(userAgent)) {
    return DeviceOS.WINDOWS;
  }

  if (/android/i.test(userAgent)) {
    return DeviceOS.ANDROID;
  }

  // iOS detection from: http://stackoverflow.com/a/9039885/177710
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return DeviceOS.IOS;
  }

  return DeviceOS.UNKNOWN;
}

export const getInterpolatedString = (label, value) => {
  const _label = label.replace(/{{.*}}/, value);
  return _label;
};

export const getDefaultTableComponent = (tcViewArray) => {
  let defaultView = tcViewArray.filter((view) => {
    return view.isUserDefault
  });
  if (defaultView.length === 0) {
    defaultView = tcViewArray.filter((view) => {
      return view.isSystemDefault;
    });
  }
  return defaultView[0].tcViewId;
};

export const convertLatInDecimal = (lat) => {
  const originalLatLng = lat;
  if (lat && !lat.includes(".")) {
    if (lat.includes("-")) {
      const latLngArr = lat.split("-");
      if (latLngArr && latLngArr.length > 0) {
        lat = latLngArr[1];
      }
    }
    if (lat?.length > 6) {
      const len = lat.length;
      lat = lat.substring(0, len - 6) + "." + lat.substring(len - 6);
    } else {
      lat = "0" + lat;
      const len = lat.length;
      lat = lat.substring(0, len - 6) + "." + lat.substring(len - 6);
    }
    if (originalLatLng.includes("-")) {
      const latLng = `-${lat}`;
      lat = latLng;
    }
  }
  return lat;
}

export const convertLngInDecimal = (lat) => {
  const originalLatLng = lat;
  if (lat && !lat.includes(".")) {
    if (lat.includes("-")) {
      const latLngArr = lat.split("-");
      if (latLngArr && latLngArr.length > 0) {
        lat = latLngArr[1];
      }
    }
    if (lat?.length > 6) {
      const len = lat.length;
      lat = lat.substring(0, len - 6) + "." + lat.substring(len - 6);
    } else {
      lat = "0" + lat;
      const len = lat.length;
      lat = lat.substring(0, len - 6) + "." + lat.substring(len - 6);
    }
    if (originalLatLng.includes("-")) {
      const latLng = `-${lat}`;
      lat = latLng;
    }
  }
  return lat;
}

export const convertDMSLat = (lat) => {
  if (!lat.includes(".")) {
    if (lat?.length > 6) {
      const len = lat.length;
      lat = lat.substring(0, len - 6) + "." + lat.substring(len - 6);
    } else {
      lat = "0" + lat;
      const len = lat.length;
      lat = lat.substring(0, len - 6) + "." + lat.substring(len - 6);
    }
  }
  var d = Math.floor(lat);
  var minfloat = (lat - d) * 60;
  var m = Math.floor(minfloat);
  var secfloat = (minfloat - m) * 60;
  var s = Math.round(secfloat);
  // After rounding, the seconds might become 60. These two
  // if-tests are not necessary if no rounding is done.
  if (s === 60) {
    m++;
    s = 0;
  }
  if (m === 60) {
    d++;
    m = 0;
  }
  const latitudeCardinal = lat >= 0 ? "N" : "S";
  return d + "°" + m + "'" + s + '"" ' + latitudeCardinal;
}

export const convertDMSLng = (lng) => {
  //Check . present in value if not add the it before last 6 character
  if (!lng.includes(".")) {
    const data = lng.split('-');

    if (data[1]) {
      lng = data[1];
    }

    if (lng && lng.length > 6) {
      const len = lng.length;
      lng = lng.substring(0, len - 6) + "." + lng.substring(len - 6);
    } else {
      lng = "0" + lng;
      const len = lng.length;
      lng = lng.substring(0, len - 6) + "." + lng.substring(len - 6);

    }

    // if (data[0] && data[0].length > 6) {
    //   lng = data[0] + lng;
    // }else{
    //   console.log(lng);
    // }
  }
  const absolute = Math.abs(lng);
  const degrees = Math.floor(absolute);
  const minutesNotTruncated = (absolute - degrees) * 60;
  const minutes = Math.floor(minutesNotTruncated);
  const seconds = Math.floor((minutesNotTruncated - minutes) * 60);
  const longitudeCardinal = lng >= 0 ? "E" : "W";
  return degrees + "°" + minutes + "'" + seconds + '"" ' + longitudeCardinal;
}

export const dateDiffInDays = (startDate, endDate) => {
  if (startDate && endDate) {
    endDate.setHours(0);
    startDate.setHours(0);
    var x = ((endDate.getTime() - startDate.getTime()) / (1000 * 60 * 60 * 24));
    if (x < 1 && x >= 0) {
      return 1;
    }
    return x;
  }
  return null;

}